export default "__VITE_ASSET__109b7ca1__"